/* Longshade action buttons: plain labels; arrows only communicate a control. */
(() => {
  'use strict';
  const selectors = [
    '.btn', '.button', '.btn-primary', '.btn-outline', '.ls-sg-btn',
    '.ls-hsf__button', '.ls-fpf__button', '.ls-zinga-button', '.ls-zinga-404__btn',
    '.ls-zinga-header-cta', '.ls-zinga-mobile-menu__cta', '.ls-zinga-footer__button',
    '.ls-zip-button', '.ls-zip-visit__button', '.ls-start-shading__button',
    '.ls-pergola-product__quote', '.ls-zip-model__quote', '.ls-curtain-card__cta', '.product-compare-card__subtitle-cta',
    '.ls-product-inquiry__submit', '.ls-product-inquiry__fit-check-cta',
    '.ls-zipblind-product__submit', '.ls-zipblind-product__fit-check-cta',
    '.location-search-btn', '.find-location-btn', '.btn-send', '.modal-submit-btn',
    '.quote-btn', '.collectionsBannerContainerTextBtn', '.indexQuoteContainerContentButton',
    '.banner-contact-btn', '.view-more-btn', '.cta-banner-button', '.ls-banner-btn',
    '.ls-catalog-intro-cta', '.ls-showcase-btn', '.ls-team-btn', '.ls-testimonial-btn',
    '.ls-wb-card-btn', 'input[type="submit"]', 'button[type="submit"]'
  ].join(',');
  const excluded = /(?:unstyled|menu-button|toggle|accordion|faq|close|prev|next|pagination|arrow-btn|blog-arrow|slick|carousel|slideshow|tab(?:\s|$)|filter|cat-btn|quantity|share|reset|account|zoom|play|calendar|floating|whatsapp-btn|back-to-top|skip-to-content)/i;
  const arrows = /^[\s\u00a0]*[→↗➜➔⟶↘]+[\s\u00a0]*$/u;
  const trailingArrow = /[\s\u00a0]*[→↗➜➔⟶↘]+[\s\u00a0]*$/u;
  const visibleText = element => element.matches('input') ? element.value : element.textContent.trim();

  function normalize(element) {
    if (!element.matches('a,button,input,[role="button"]') ||
        element.closest('.mobile-sticky-cta') || excluded.test(element.className || '') ||
        element.matches('.cart-items__remove') ||
        element.matches('[role="tab"],[aria-expanded],[data-ls-keep-icon]')) return;
    const text = visibleText(element);
    // Icon-only controls and explicit Back/Previous actions keep their meaning.
    if (!text || arrows.test(text) || /^[←‹«]|^(?:<\s*)?back\b|^previous\b/i.test(text)) return;
    element.classList.add('ls-action-button');
    const secondary = /(?:--outline|--secondary|btn-outline|btn-secondary|button-secondary)/i.test(element.className);
    element.classList.toggle('ls-action-button--secondary', secondary);
    if (element.matches('input')) {
      element.value = element.value.replace(trailingArrow, '');
      return;
    }
    // Change only text nodes; keep form status hooks, link destinations and listeners.
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement.closest('svg,script,style,.visually-hidden,.sr-only')) continue;
      const next = node.nodeValue.replace(trailingArrow, '');
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    for (const icon of element.querySelectorAll('svg,[class*="Icon"],[class*="arrow"],.banner-btn-icon')) {
      const cls = icon.getAttribute('class') || '';
      const viewBox = icon.getAttribute('viewBox') || '';
      const path = icon.querySelector('path')?.getAttribute('d') || '';
      const isArrow = /arrow|BtnIcon|ButtonIcon|banner-btn-icon/i.test(cls) ||
        viewBox === '0 0 11 11' || /^M0 11V9\.625|^M0 16V14H12\.59|^M5 12h14M12 5l7 7-7 7/i.test(path);
      if (isArrow) icon.classList.add('ls-action-decorative-arrow');
    }
    // Empty arrow spans must not retain a flex gap beside the label.
    for (const span of element.querySelectorAll('span[aria-hidden="true"]')) {
      if (!span.textContent.trim() && !span.children.length) span.classList.add('ls-action-decorative-arrow');
    }
  }

  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.(selectors)) normalize(root);
    root.querySelectorAll(selectors).forEach(normalize);
  }
  function start() {
    scan(document);
    // Finder steps, form success/error states and Shopify sections can replace content.
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') {
          const button = record.target.parentElement?.closest(selectors);
          if (button) normalize(button);
        } else {
          for (const node of record.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) scan(node);
            const button = node.parentElement?.closest(selectors);
            if (button) normalize(button);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
